import STATUS_CODES from 'constants/statusCodes';

export const DISCLAIMER_TYPES = {
	CONNECT_ACCOUNTS: 'connect_accounts',
	ADDITIONAL_SECURITY: 'additional_security',
};

export const getDisclaimerType = (signInResponse) => signInResponse?.error?.data?.okta_disclaimer_type;

export const isUserForcedToConnectWithOkta = (signInResponse) =>
	signInResponse?.status === STATUS_CODES.FORBIDDEN &&
	Object.values(DISCLAIMER_TYPES).includes(getDisclaimerType(signInResponse));
